import { render } from "./QuranProgramsSchedules.vue?vue&type=template&id=569811b8&scoped=true"
const script = {}

import "./QuranProgramsSchedules.vue?vue&type=style&index=0&id=569811b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569811b8"]])

export default __exports__